import React, { useEffect, useState } from 'react';
import { Table, Dropdown, Menu, Checkbox, Select, Button, Modal, message } from 'antd';
import { EllipsisOutlined, UnorderedListOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { partnerChangeHistoryData, remarkData } from '../helper/payoutdatasample';
import PartnerChangeHistory from '../PartnerChangeHistory';
import RemarksComponent from '../RemarksComponent';
import useSession from '../../CustomLogout/useSession';
import { addReamapRemarkAction, getLanHoldApprovalSuccess, getremaphystorydata, getRemarksLanSuccess } from '../../../redux/PayoutLanData/Action';
import { Form } from 'antd';
import { connect } from 'react-redux';
import { Payout_Service } from '../../../redux/Url';
import { Spin } from 'antd';


// const { Option } = Select;

const LanlistWithPayoutChecker = (props) => {
  const {
    landataSource,
    setLanDatasource,
    makerAction,
    checkerAction,
    setMakerAction,
    setCheckerAction,
    handleRadioChange,
    radiostate,
    setRadioState,
    handleCheckboxChange,
    selectedCheckboxes,
    partnerId,
    ReportId,
    fetchPaginatedData,
    holdAction,
    setHoldAction,
    remapAction,
    setRemapAction,
    pagination,
    onPageChange,
    downloadAction,
    setDownloadAction,
    recovery,
    setRecovery,
    fileApprovalId,
    setFileApprovalId,
    remap,
    setRemap,
    loading,
  } = props;
  const [form] = Form.useForm();
  const [datasource, setDatasource] = useState([]);
  const [editableRow, setEditableRow] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [pmapremark, setPmapremark] = useState("");
  const [ispmapremarkVisble, setPmapremarkVisble] = useState(false);
  const [isholdPayoutVisble, setIsholdPayoutVisble] = useState(false);
  const [partnerChangeOpen, setPartnerChangeOpen] = useState(false);
  const [partnerChangeData, setPartnerChangeData] = useState(partnerChangeHistoryData);
  const [remarks, setRemarks] = useState(false);
  const [partnerRemarks, setPartnerRemarks] = useState([]);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [remarkComment, setRemarkComment] = useState('');
  const handleSessionExpired = useSession();
  const [approveModal, setApproveModal] = useState(false);
  const [approveRemarks, setApproveRemarks] = useState('');
  const [selectedPayoutId, setSelectedPayoutId] = useState('');
  const [selectedHoldLanNo, setSelectedHoldLanNo] = useState('');
  const [holdStageReson, setHoldStageReason] = useState('');
  const [remapModal, setRemapModal] = useState(false);
  const [remapApproveRemarks, setRemapApproveRemarks] = useState('');
  const [remapData, setRemapData] = useState([]);
  const [resDataRM, setresDataRm] = useState([]);
  const [isLoading, setIsLoading] = useState(null);


  useEffect(() => {
    setDatasource(landataSource);
  }, [landataSource, radiostate]);

  const handleMenuClick = (record, action) => {
    if (action === 'ExportCSV') {
      downloadReport('csv');
    } else if (action === 'ExportExcel') {
      downloadReport('excel');
    } else if (action === 'RemappingHistory') {
      setPartnerChangeOpen(true);
      fechRemapdata(record)
    } else if (action === 'AddRemark') {
      setRemarks(true);
    }
  };

  const handlePartnerChange = (value, record) => {
    setSelectedPartner(value);
    setPmapremarkVisble(true);
  };

  const handleCloseModalpmapremark = () => {
    setPmapremarkVisble(false);
    setPmapremark("");
  }
  const handleCloseModalholdPaout = () => {
    setIsholdPayoutVisble(false);
  }

  const handelsavePremark = () => {
    setPmapremarkVisble(false);
  }

  // Fetch remarks for a partner
  const fetchPartnerRemarks = async (partnerId) => {
    try {


      const getRemarks = await props.getPayoutRemarks({
        accessToken: props.accessToken,
        reportId: ReportId, // Assuming ReportId is the report ID you want to use
        partnerId: partnerId,
      })
      const data = await getRemarks;
      const errorCode = data?.response?.data?.errorCode || data?.errorCode;
      if (errorCode === "403" && (data?.response?.data?.errorCode || data?.errorCode)) {
        handleSessionExpired();
        return;
      }
      setPartnerRemarks(data || []); // Assuming the API returns data in a 'data' field
      // Optionally dispatch to Redux if needed:
      // props.getPayoutRemarksSuccess(data);
      return data;
    } catch (error) {
      setPartnerRemarks([]);
      return [];
    }
  };

  const fechRemapdata = async (record) => {

    try {
      const resgetReampHdata = props.getremaphystorydata({
        accessToken: props.accessToken,
        lanNo: record.lanNo
      });

      const data = await resgetReampHdata;
      const errorCode = resgetReampHdata?.response?.data?.error?.errorCode || resgetReampHdata?.response?.status;
      if (errorCode && errorCode === "403" && (resgetReampHdata?.response?.data?.error?.errorCode || resgetReampHdata?.response?.status)) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }
      setPartnerChangeData(data || []);

    } catch (error) {
      console.error("Error fetching remap history data:", error);
      message.error("Failed to fetch remap history data");


    }

  }


  const downloadReport = async (format) => {
    try {
      const response = await fetch(
        // `http://localhost:8301/partner-payout-service/reports/payout-lan-report-export?lanTab=${radiostate}&reportId=${ReportId}&partnerId=${partnerId}&format=${format}`,
        `${Payout_Service}/reports/payout-lan-report-export?lanTab=${radiostate}&reportId=${ReportId}&partnerId=${partnerId}&format=${format}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + props.accessToken, // Use the access token from props
          },
        }
      );
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = format === 'csv' ? 'report.csv' : 'report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Successfully downloaded the report');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Download failed:', error);
    }
  };

  const fatechRemarLanLavel = async (record) => {

    const lanRemarkdata = await props.getLanRemarkData({
      accessToken: props.accessToken,
      payoutId: record.payoutId
    })
    return lanRemarkdata;


  }

  const handleRemarksModal = async (record, key) => {

    setIsLoading(key)

    const resData1 = await fatechRemarLanLavel(record)
    setIsLoading(null);

    const flatArray = Object.values(resData1).flat();

    const resData = formatRemarks(flatArray)

    if (resData.length > 0) {

      setRemarks(true);
      setresDataRm(resData);

    } else {
      message.error("No remarks found for this record.");
      setIsLoading(null);
    }





  }

  const handelAddRemarks = async (remarkComment, partnerId = selectedPartnerId) => {



    const remarksData = {
      "partnerId": partnerId,
      "reportId": ReportId,
      "userId": props.userDetail?.userId,
      "remarksComment": remarkComment,
      "stage": null,
      "remarkType": "Partner"
    };
    const resReamatkadd = await props.PartnerRemarkadd({
      accessToken: props.accessToken,
      remarks: remarksData
    });

    await fetchPartnerRemarks(partnerId);
  }

  const formatRemarks = (remarks) => {
    const sortdata = remarks.sort((a, b) => {
      const dateA = new Date(a.createDateTime);
      const dateB = new Date(b.createDateTime);


      return dateA.getTime() - dateB.getTime(); // Newest first
    });

    return remarks
      ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
      .map((remarks) => (
        <div className='containerRemarks' style={{ display: 'block' }} key={remarks.lanRemarkId}>
          <div style={{ display: 'flex' }}>
            <b>{remarks.createdByName}</b>
            <b className='userRole' >({remarks.createdByRole})</b>
          </div>
          <div style={{ display: 'grid' }} className='commentContainer'>
            <span style={{ maxWidth: "200px" }}> {remarks.remarks} </span>
            <small>
              {new Date(remarks.createdDate).toLocaleString()}| Reason:{remarks.lanRemarkType}
            </small>
          </div>
        </div>
      ));
  };

  // var resData = formatRemarks(remarkData)

  const handleSavePartnerChange = (record) => {
    // setSelectedPartner(value);
    const updatedData = datasource.map((item) => {
      if (item.DISB_FILE_NO === record.DISB_FILE_NO) {
        return { ...item, PartnerName: selectedPartner };
      }
      return item;
    });
    setDatasource(updatedData);
    setEditableRow(null);
    setSelectedPartner('');
    setPmapremark("");
  };

  // const onChange = (value) => {
  //   console.log(`selected ${value}`);
  // };

  // const onSearch = (value) => {
  //   console.log('search:', value);
  // };


  const handleCancel = () => {
    setApproveModal(false);
    setRemapModal(false);
  }

  const handleApproveModal = (payoutid, holdStage, lanNo) => {
    setApproveModal(true);
    setSelectedPayoutId(payoutid);
    setHoldStageReason(holdStage);
    setSelectedHoldLanNo(lanNo);
  }

  const handleApproveSubmit = async () => {
    setIsLoading(true);
    try {
      const partnerid = selectedPartnerId;
      await props.getLanHoldApprovalSuccess({
        accessToken: props.accessToken,
        payoutId: selectedPayoutId,
        lanNo: selectedHoldLanNo,
        holdStageId: 3,
        holdReason: holdStageReson,
        remarksComment: approveRemarks,
        userId: props.userDetail?.userId,
      });
      setApproveRemarks(''); // Clear the approve remarks input
      setApproveModal(false); // Close the modal
      // fetchPayoutStagesData(); // Refresh the stages data
      fetchPaginatedData(radiostate); // Refresh the data after submission

      message.success('Partner approved successfully!'); // Show success message
    } catch (error) {
      console.error("Error submitting approve remarks:", error);
      message.error('Failed to approve partner. Please try again.'); // Show error message
    } finally {
      setIsLoading(false);
    }
  };

  const handleHeaderMenuClick = (key) => {
    switch (key) {
      case 'ExportCSV':
        downloadReport('csv');
        break;
      case 'ExportExcel':
        downloadReport('excel');
        break;
      case 'AddRemark':
        setRemarks(true)
        break;
      default:
    }
  };


  const handleRemapApproveModal = (record) => {
    setRemapModal(true);
    setRemapData(record)
  }


  const handleRemapApproveSubmit = async () => {
    try {

      const data = {
        "oldPartnerId": remapData.forRemapOldPartnerId,
        "newPartnerId": remapData.forRemapNewPartnerId,
        "lanNo": remapData.lanNo,
        "payoutId": remapData.payoutId,
        "remarks": remapApproveRemarks,
        "file": remapData.forRemapFilePath,
        "remapStageId": 3,
        "userRole": props?.userDetail?.roleName,
        "createdBy": props?.userDetail?.userId

      }

      const res = await props.addReamapAction({
        accessToken: props.accessToken,
        Remapdata: data,
      });

      const errorCode = res?.data?.error?.errorCode || res.errorCode;
      if (errorCode && errorCode === 403 && (res?.data?.error?.errorCode || res.errorCode)) {
        handleSessionExpired(); //Logout the user if session expired
        setRemapData([]);
        return;
      }
      setRemapModal(false);
      await fetchPaginatedData(radiostate); // Wait for data to refresh

      message.success('Remap approved successfully!'); // Show success message
      setRemapData([]);
      return res;
    } catch (error) {
      message.error('Failed to approve remap. Please try again.');
      setRemapData([]);
      return error;
    }
  }

  const headerMenu = (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key)}
      items={[
        { label: 'Export to CSV', key: 'ExportCSV' },
        { label: 'Export to Excel', key: 'ExportExcel' },
        // { label: 'Hold Payout(Bulk Action)', key: 'HoldPayoutBulk' },
        // { label: 'Add/ View Remark(Partner)', key: 'AddRemark' },
      ]}
    />
  );



  const columns = [
    // ...(makerAction && checkerAction
    //   ? [
    //       {
    //         title: 'Check',
    //         dataIndex: 'Check',
    //         key: 'Check',
    //         fixed: 'left',
    //         width: 60,
    //         render: (_, record) => (
    //           <Checkbox
    //             checked={selectedCheckboxes.Check.includes(record)}
    //             onChange={(e) => handleCheckboxChange(e, 'Check', record)}
    //           />
    //         ),
    //       },
    //     ]
    //   : []),
    {
      title: 'Applicant Name',
      dataIndex: 'applicantName',
      key: 'applicantName',
      align: 'center',
    },
    {
      title: 'DISB_FILE_NO',
      dataIndex: 'lanNo',
      key: 'lanNo',
      align: 'center',
    },
    {
      title: 'Disbursal Date',
      dataIndex: 'disbDate',
      key: 'disbDate',
      align: 'center',

    },
    {
      title: 'Partner Name',
      dataIndex: 'partnerName',
      key: 'partnerName',
      align: 'center',
    },
    {
      title: 'Partner Code',
      dataIndex: 'partnerCode',
      key: 'partnerCode',
      align: 'center',
    },
    {
      title: '1st Disb',
      dataIndex: 'firstDisbAmount',
      key: 'firstDisbAmount',
      align: 'center',
      render: (_, amount) => (amount.disbSeq > 1 ? 0 : amount.firstDisbAmount).toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Tranche',
      dataIndex: 'disbAmount',
      key: 'disbAmount',
      align: 'center',
      render: (_, record) => (record.disbSeq > 1 ? record.disbAmount : 0).toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Disb Cumulative',
      dataIndex: 'cumulativeAmount',
      key: 'cumulativeAmount',
      align: 'center',
      width: 190,
      render: (_, record) => {
        const cumulative = record.cumulativeAmount || 0;
        return cumulative.toLocaleString("en-IN", { style: "currency", currency: "INR" });
      }
    },
    {
      title: 'Payout Status',
      dataIndex: 'transactionStatus',
      key: 'transactionStatus',
      align: 'center',
    },
    {
      title: 'Credit Amount',
      dataIndex: 'creditAmount',
      key: 'creditAmount',
      align: 'center',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Debit Amount',
      dataIndex: 'debitAmount',
      key: 'debitAmount',
      align: 'center',
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Percentage Applied',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'center',
      render: (value) => value !== undefined && value !== null ? `${value}%` : '-',
    },
    //  {
    //    title: 'Status Amount',
    //    dataIndex: 'regular',
    //    key: 'regular',
    //  },
    {
      title: 'Remark',
      dataIndex: 'Remark',
      key: 'Remark',
      align: 'center',
      render: (_, record, key) => (
        <Button loading={isLoading === key} className='remarkView-btn' style={{ border: "none", color: "#000", fontSize: "14px" }} onClick={() => handleRemarksModal(record, key)} >
          Remark
        </Button>
      )
    },
    ...(recovery
      ? [
        {
          title: 'Recovery Final Amount',
          dataIndex: 'finaRecoveryAmount',
          key: 'finaRecoveryAmount',
          align: 'center',
          width: 170,
          render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
        },
      ]
      : []
    ),
    ...(makerAction || checkerAction || downloadAction
      ? [
        {
          title: (
            downloadAction ? (
              <Dropdown overlay={headerMenu} trigger={['click']}>
                <span style={{ cursor: 'pointer' }}>
                  Action <EllipsisOutlined />
                </span>
              </Dropdown>
            ) : (
              <span style={{ cursor: 'not-allowed', color: '#ccc' }}>
                Action <EllipsisOutlined />
              </span>
            )
          ),
          dataIndex: 'Action',
          key: 'Action',
          fixed: 'right',
          align: "center",
          render: (_, record) => {
            const menu = (
              <Menu
                onClick={({ key }) => handleMenuClick(record, key)}
                items={[
                  { label: 'Remapping History', key: 'RemappingHistory' },
                ]}
              />
            );
            return (
              <>
                {remap ? <Dropdown overlay={menu} trigger={['click']}>
                  <UnorderedListOutlined
                    style={{ cursor: 'pointer', fontSize: '18px' }}
                  />
                </Dropdown> : <> </>}
                {/* {radiostate === "ONHOLD" ? <Button className='btn' disabled={record.forHoldStageId === 1 ? false : true} type="primary" style={{ marginLeft: "2%", border: "none", backgroundColor: " #f3f3f3", color: "blue", fontSize: "12px" }} onClick={() => handleApproveModal(record.payoutId, record.forHoldStageReason, record.lanNo)}>
                  {record.forHoldStageId === 3 ? 'Approved' : "Approve"}
                </Button> : null}
                {radiostate === "REMAP" ? <Button className='btn' disabled={record.forRemapStageId === 1 ? false : true} type="primary" style={{ marginLeft: "2%", border: "none", backgroundColor: " #f3f3f3", color: "blue", fontSize: "12px" }} onClick={() => handleRemapApproveModal(record)}>
                  {record.forRemapStageId === 3 ? 'Approved' : "Approve"}
                </Button> : null} */}
              </>
            )
          },
        },
      ]
      : []),
  ];

  return (
    <div style={{ maxWidth: '100%' }}>
      {loading && (
        <div style={{
          position: 'absolute',
          zIndex: 10,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255,255,255,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Spin tip="Loading..." size="large" />
        </div>
      )}
      <Table dataSource={datasource}
        pagination={pagination}
        onChange={(pagination) => {
          // Call the parent's handler if provided
          if (props.onPageChange) {
            props.onPageChange(pagination.current, pagination.pageSize, radiostate);
          }
        }} columns={columns} rowKey={(record, index) => index} scroll={{ x: "max-content" }} />
      <Modal
        title="Add Remark"
        visible={ispmapremarkVisble}
        onCancel={handleCloseModalpmapremark}
        footer={null}
      >
        <TextArea
          placeholder="Please add comment to submit"
          onChange={(e) => setPmapremark(e.target.value)}
          autoSize={{ minRows: 2, maxRows: 6 }}
        />
        <Button
          disabled={pmapremark === null}
          type="link"
          onClick={() => handelsavePremark()}
          style={{ background: "#1b8593", marginTop: "0.3rem", color: "#fff" }}
        >
          Submit
        </Button>

      </Modal>


      <Modal open={approveModal} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form>
          <Form.Item style={{ marginBottom: 0 }}>
            <TextArea style={{ marginTop: 20 }} name='ApproveRemarks' onChange={(e) => setApproveRemarks(e.target.value)} placeholder='Please add Approve Remark' autoSize={{ minRows: 3, maxRows: 5 }}>
            </TextArea>
            <Button loading={isLoading} className='btn-query' onClick={handleApproveSubmit} type="submit">Approve </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal open={remapModal} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form>
          <Form.Item style={{ marginBottom: 0 }}>
            <TextArea
              style={{ marginTop: 20 }}
              name='ApproveRemarks'
              value={remapApproveRemarks}
              onChange={e => setRemapApproveRemarks(e.target.value)}
              placeholder='Please add Approve Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
            <Button className='btn-query' onClick={handleRemapApproveSubmit} type="submit">Approve </Button>
          </Form.Item>
        </Form>
      </Modal>

      <PartnerChangeHistory
        partnerChangeData={partnerChangeData}
        setPartnerChangeData={setPartnerChangeData}
        partnerChangeOpen={partnerChangeOpen}
        setPartnerChangeOpen={setPartnerChangeOpen}
      // resData={resData}
      />
      <RemarksComponent
        resData={resDataRM}
        remarks={remarks}
        setRemarks={setRemarks}
        // handelAddRemarks ={handelAddRemarks}
        // setRemarkComment={setRemarkComment}
        isHistory={true}
      />
    </div>
  );
};




const mapDispatchToProps = (dispatch) => {
  return {
    getLanHoldApprovalSuccess: (data) => dispatch(getLanHoldApprovalSuccess(data)),
    addReamapAction: (data) => dispatch(addReamapRemarkAction(data)),
    getLanRemarkData: data => dispatch(getRemarksLanSuccess(data)),
    getremaphystorydata: data => dispatch(getremaphystorydata(data)),
  }
};

const mapStateToProps = (state) => {
  return {


    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LanlistWithPayoutChecker);